import { useEffect, useRef } from 'react'
import {useIsomorphicLayoutEffect} from "react-redux/es/utils/useIsomorphicLayoutEffect";

export function useInterval(callback: () => (void | number), delay: number | null) {
  const savedCallback = useRef(callback)

  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!delay && delay !== 0) {
      return
    }

    const id = setInterval(() => savedCallback.current(), delay)

    return () => clearInterval(id)
  }, [delay])
}
